/*import tim from '../../tim.js'
import TIM from 'tim-js-sdk/tim-js-friendship'*/
import {chatNetRecommendResumes, netTalkCompany, sendJobChat} from '@/api/company'
import { Toast } from 'vant'
const company = {
    namespaced: true,
    state: {
        recommendResumes:[],
    },
    getters: {

    },
    mutations: {
        setRecommendResumes(state, data) {
            state.recommendResumes = [...state.recommendResumes, data]
        },
    },
    actions:{
        sendJobChat(context,param) {
            sendJobChat(param.userId,param.toUserId,param.jobId).then(res => {
                if (res.status===200) {
                    Toast('发送成功')
                }else{
                    Toast.fail(res.message)
                }
            })
        },
        chatNetRecommendResumes(context,param) {
            return new Promise((resolve) => {
                chatNetRecommendResumes(param.jobfair_id,param.limit,param.page).then(res => {
                    if (res.status===200) {
                        context.state.recommendResumes=res.data.data.recommendResumes
                    }else{
                        Toast.fail('获取推荐求职者失败！')
                        context.state.recommendResumes={}
                    }
                    resolve()
                })
            })
        },
        async netTalkCompany(context,param){
            try {
                return await netTalkCompany(param.jobId,param.toUserId,param.jobfair_id)
            }catch (e) {
                throw new Error('发起洽谈失败')
            }
        },
    },
}

export default company
